import { CALL_TYPE_ID, COMMUNICATION_TYPE_ID, EMAIL_TYPE_ID, ENGAGEMENT_TYPE_ID, MEETING_EVENT_TYPE_ID, NOTE_TYPE_ID, POSTAL_MAIL_TYPE_ID, TASK_TYPE_ID } from '../constants/ObjectTypeIds';
export const ENGAGEMENT_TYPE_IDS = [CALL_TYPE_ID, COMMUNICATION_TYPE_ID, EMAIL_TYPE_ID, ENGAGEMENT_TYPE_ID, MEETING_EVENT_TYPE_ID, NOTE_TYPE_ID, POSTAL_MAIL_TYPE_ID, TASK_TYPE_ID];
export const isEngagementTypeId = objectTypeId => {
  return ENGAGEMENT_TYPE_IDS.includes(objectTypeId);
};